var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"caret-wrapper"},[_c('i',{staticClass:"sort-caret ascending",class:[this.sort == this.field && this.order == 'desc' ? 'active' : '']}),_vm._v(" "),_c('i',{staticClass:"sort-caret descending",class:[this.sort == this.field && this.order == 'asc' ? 'active' : '']})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f7295b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/doc-out/SortCaret.vue
// module id = null
// module chunks = 